/**
 * Signal global de rafraîchissement manuel -- alimente le bouton
 * "Rafraîchir" de la Sidebar (à côté de l'indicateur de connexion WS).
 *
 * Volontairement minimal : un simple compteur réactif. `createWsStore`
 * (voir `$lib/ws.svelte.ts`) s'y abonne déjà pour TOUTES les pages qui
 * l'utilisent (accueil, Valheim, Palworld, Système…) en forçant une
 * reconnexion immédiate de son WebSocket -- une reconnexion renvoie
 * toujours un instantané complet et à jour au handshake côté backend, donc
 * fermer/rouvrir EST le refetch le plus simple, sans avoir à câbler une
 * route REST dédiée par page ni à dupliquer la logique de chargement.
 */
class RefreshBus {
	tick = $state(0);

	bump() {
		this.tick++;
	}
}

export const refreshBus = new RefreshBus();
